module.exports = __webpack_public_path__ + "img/avatar-2.87677a58.png";